import { useCallback } from "react";
import { useStore } from "../store";
import { ContextKey } from "../types/context-key";

const useOnValueChange = (key: ContextKey) => {
  const context = useStore().context;
  const onValueChange = useCallback(
    (value: number | boolean) => {
      context.updateKey(key, value);
    },
    [context, key]
  );

  return onValueChange;
};

export default useOnValueChange;
